import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { pages } from '../../../../@core/interfaces/ehr/visit';
import { UsertypeData } from '../../../../@core/interfaces/masters/usertype';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../service/date.service';
import { StickersComponent } from '../stickers/stickers.component';
import { patientoptimizationData } from '../../../../@core/interfaces/masters/patientoptimization';
import { access } from '../../../../data/access-constants';
import { environment } from '../../../../../environments/environment';
import { ToastrAppSrvcService } from '../../../../_services/toastr-app-srvc.service';
@Component({
  selector: 'ngx-patient-quick-search',
  templateUrl: './patient-quick-search.component.html',
  styleUrls: ['./patient-quick-search.component.scss']
})
export class PatientQuickSearchComponent implements OnInit {

  @Input() searchWord:any;
  @Input() accessFrom:string;
  @Input() patientDatas:any=[];
  patientData:any={
    name:null,
    lastname:null,
    gender:null,
    age:null,
    bloodgroup:null,
    regId:null,
    regNum:null,
    nhid:null
  };
  isAbhaView: boolean = false;
  openAbhaPopup: boolean = false;
  patientAddressline1:string;
  patientAddressline2:string;
  patientParentGuarStatus:string;
  patientCity:any;
  patientDoorNumber:string;
  patientPincode:string;
  patientCurrentCity:string;
  patientMobileNUmber:string;
  isquicksearch:Boolean=false;

  general:string=pages.GENERAL;
  gynecology:string=pages.GYNECOLOGY;
  healthRecord:string="healthRecord";
  obs:string=pages.OBSTERITICS;
  dental:string=pages.DENTAL;
  pediatrics:string=pages.PEDIATRICS;
  ip: string = pages.IP;
  currentAdmId:string;
  ehrdefaultpage:string='general';

  openStickerPopup:boolean=false;
  OP:string='OP';

  p:number=1;
  patientSelected:boolean = false;
  count:number = 1;
  rowClicked:number;

  userAccessData: Array<any>=[];
  pageTaskIds: Array<any>=[];
  dischargeListFlag:boolean=false;
  admissionlistFlag:boolean=false;
  cancelledListFlag:boolean=false;
  caretakerFlag:boolean=false;
  ipFlag: boolean=false;
  private apiUrl = environment.apiUrl;

  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = localStorage.getItem("userId");
  protected readonly unsubscribe$ = new Subject<void>();
  public multiBranchAccess = localStorage.getItem("accessPatientAccrossAllbranches")=="Active" ? true : false;

  @ViewChild('stickerInst') stickerInstance: StickersComponent;
  srcname: string;
  currencySymbol:string = localStorage.getItem("LoginCountryDet") ? JSON.parse(localStorage.getItem("LoginCountryDet")).symbol : '';
  packageFlag: boolean;
  otFlag: boolean;
  walletFlag: boolean;

  isActivepat: string
  decesedpat: boolean
  decesedRes: any
  deceasedList: Array<any> = [];
  admisssionStatus: string;

  convertData:any={};
convertFlag:boolean=false;

  constructor(private toaster: ToastrAppSrvcService,
    private poSrvc: patientoptimizationData ,
    protected usertypeService: UsertypeData,
      public datService:DateService,private routers: Router,
      protected rolesService: RolesData, private route: ActivatedRoute,
      public location:Location, protected patRegSrvc: PatientRegistrationData) {

        this.route.params.subscribe(params => {
          this.searchWord = params['searchWord'];
          this.searchpatient();
        });

       }

  ngOnInit(): void {
    this.fetchPageAccess();
    const flag = localStorage?.getItem('referralFlag');
    if(!!flag){
    localStorage.removeItem('referralFlag');
    localStorage.removeItem('DEPTID');
    localStorage.removeItem('refRegId');
    localStorage.removeItem('refappt') 
    localStorage.removeItem('refPcId');
    localStorage.removeItem('refVisit');
    localStorage.removeItem('DOCID');
   }
   if(!!JSON.parse(localStorage?.getItem('dpMst'))){
     localStorage.removeItem('dpMst')}
  }

  selectPat(x,index?){
    if(this.count > 1 || this.patientData.length == 1){
      this.patientSelected = true;
    }
    this.count++;
    if(this.rowClicked === index){
      this.rowClicked = -1;
    }
    else {
      this.rowClicked = index;
    }
    this.patientData={
      name:x?.firstname,
      lastname:x?.lastname,
      gender:x?.gender ,
      age:x?.age ,
      dob:x?.dob,
      ageResult:x?.ageResult,
      dobFlag:x?.dobFlag,
      status:x?.status,
      // address1:x?.a,
      // address2:x?.a,
      // address3:x?.a,
      // height:x?.a ,
      // weight:x?.a ,
      bloodgroup:x?.bloodGroup ,
      // lastvist:x?.a ,
      // totalVisit:x?.a,
      regId:x?.id,
      regNum:x?.regNum,
      nhid:x?.nhid,

      isunregisterPatientConverted:x?.isunregisterPatientConverted
    }
    this.patientAddressline1 = x?.address1;
    this.patientAddressline2 = x?.address2;
    this.patientParentGuarStatus = x?.parentOrGuardianName;
    this.patientDoorNumber = x?.doorno;
    this.patientPincode = x?.pincode;
    this.patientCurrentCity = x?.city;
    this.patientMobileNUmber=x?.mobile;
    this.poSrvc.list(`optimization/${x.id}/${this.tenantId}/${this.branchId}/PatientHeaderDetails`).pipe(takeUntil(this.unsubscribe$)).subscribe((imgdata: any) => {
      this.isActivepat = imgdata?.header[0]?.lastVisit[0]?.patientRegistration?.isActive
      this.decesedpat = imgdata?.header[0]?.lastVisit[0]?.patientRegistration?.deceasedFlag
      this.decesedRes = imgdata?.header[0]?.lastVisit[0]?.patientRegistration?.deceasedReasonId;
      this.admisssionStatus=imgdata.admissionStatus;
      this.currentAdmId=imgdata?.admissionId;
      this.getDecesedlist()
      if(imgdata.image!=null){
        this.srcname = 'data:image/jpeg;base64,' + imgdata.image;
      }else{
        this.srcname = "../../../../assets/images/Avatar-profile.svg";
      }
    });
  }

  getDecesedlist(){
    this.poSrvc.list('deathReasonMaster/getAllReasonMaster?'+'tenantId='+ this.tenantId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.deceasedList = data.details.filter(x => x.isActive == true);
      if (this.decesedRes !== null) {
        const reasonName = this.deceasedList.find(
          reason => reason.id === this.decesedRes
        );
        this.decesedRes = reasonName ? reasonName.name : null;
      }
    }, (error) => {

    }, () => {

    });
  }
  ngAfterViewInit(): void {

  }
  routerNavigate1(route: string, regId: string, isFromPtList: string, isAdd: string, regNum: string): void {
    this.routers.navigate([route, regId, isFromPtList, isAdd, regNum]);
  }

  searchpatient(){
    if(!this.tenantId || this.tenantId === 'null' || this.tenantId === 'undefined' || !this.branchId){return;}
    var searchData={
      "searchWord":this.searchWord,
      "fromDate": null,
      "toDate": null,
      "skip": 0,
      "take": 100,
      "tenantId":this.tenantId,
      "branchId":this.multiBranchAccess? null : this.branchId,
    };
 
    const apiUrl =`PatientRegistrationMst/${this.tenantId}/${this.branchId}/newPatientList`;
  this.patRegSrvc.searchList(apiUrl, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((dataResponse: any) => {
      if(dataResponse.details.length>0){
        this.patientDatas=dataResponse.details;
        this.patientData=dataResponse.details;
        this.selectPat(this.patientDatas[0])
        this.isquicksearch=true;
      }
      else{
        this.patientDatas=[];
      }
    },
    (error) => {
    },
    () => {
    });
    this.patientSelected = false;
    this.count = 1;
    //this.getdefaultEHRpage();
  }
  getdefaultEHRpage(){
    this.usertypeService.getall(`dashboardAccess/${this.tenantId}/${this.branchId}/${this.userId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      if(data.length>0){
        let defaultEHRData=data.filter(module => module.isDefault=='Y')
        if(defaultEHRData.length>0){
          this.ehrdefaultpage=defaultEHRData?.[0]?.dashboardMst.dashboardModuleDesc.toLocaleLowerCase();
        }
        else{
          this.ehrdefaultpage='general';
        }
      }
       else{
        this.ehrdefaultpage='general';
      }
    }, (error) => {
            this.ehrdefaultpage='general';
    }, () => {
    });
  }

  calculateNoOfMonthBetweenTwoDates(dob, ageResult, dobFlag): any {

    if (dobFlag == "Y") {
      var startDate = new Date(dob);
      var endDate = new Date();

      return Math.max(
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        endDate.getMonth() -
        startDate.getMonth(),
        0)
    } else {
      var startDate = new Date(ageResult);
      var endDate = new Date();

      return Math.max(
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        endDate.getMonth() -
        startDate.getMonth(),
        0)

    }
  }
  closeQS(){
    this.isquicksearch=false;
  }

  routerNavigate(url,param,title?){
     if(title=="obstetrics"){
       this.routers.navigate(['/pages/ehr/ehrdashboard'+"/"+param+"/obs/healthRecord/"+this.patientData.status]);
     }
     else if(title=='general'){
      this.routers.navigate(['/pages/ehr/ehrdashboard'+"/"+param+"/general/healthRecord/"+this.patientData.status]);
     }
     else if(title=='dental'){
      this.routers.navigate(['/pages/ehr/ehrdashboard'+"/"+param+"/dental/healthRecord/"+this.patientData.status]);
     }
     else if(title=='gynecology'){
      this.routers.navigate(['/pages/ehr/ehrdashboard'+"/"+param+"/gynecology/healthRecord/"+this.patientData.status]);
     }
     else if(title=='pediatrics'){
      this.routers.navigate(['/pages/ehr/ehrdashboard'+"/"+param+"/pediatrics/healthRecord/"+this.patientData.status]);
     }
     else if(this.openAbhaPopup == true){
      
      this.routers.navigate([url, param ,this.openAbhaPopup]);
     }
     else{
       this.routers.navigate([`${url+"/"+param}`]);
     }
   }
   navBill(x) {
    var data = x.regId;
    var link = "/pages/pharmacy/sales?regId?admId";
    this.routers.navigate([`${link.split('?')[0]}`], { queryParams: { regId: data,admId:this.currentAdmId } });
  }

   gotootBooking(regid){
    //  var link = "/pages/ot/booking?regId" + regid;
    //  this.routers.navigate([`${link.split('?')[0]}`], { queryParams: { regId: regid, back:true } });

      var data =regid + "_"  + "GlobalSearch" + "_" + this.currentAdmId;
      var link = "/pages/ot/patient-ot-list?data";
      this.routers.navigate([`${link.split('?')[0]}`], { queryParams: { data: data } });
   }

   gotobilling(regId,patientName){
     var id =regId + "," + patientName;
     var link = "/pages/patientservices/op-billing?id";
     this.routers.navigate([`${link.split('?')[0]}`], { queryParams: { id: id } });
   }
   navPackage(data){
    var regId = data.regId;
    this.routers.navigate(['/pages/general-package/package-dashboard'], { queryParams: { regId: regId } });
   }
   stickerPopup(){
    this.openStickerPopup=true;
    setTimeout(() => {
      this.stickerInstance.serDefaultValues();
      },50 );
   }
   popUpClose(){
    this.openStickerPopup=false;
    setTimeout(() => {
    this.stickerInstance.onReset();
    },50 );
   }

   mainprevclicked() { if (this.p > 1) this.p = this.p - 1 }
  mainnextclicked() { if (this.p < (this.patientDatas.length / 4)) { this.p = this.p + 1 } }

  getPatientAgeByDOB(dob, ageResult, dobFlag): any {

    if (dobFlag == "Y") {

      var patientDob = new Date(dob);

      var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
      ageValue = Math.trunc(ageValue);
      //extract the year, month, and date from user date input
      var dobMonth = patientDob.getMonth();
      var dobDate = patientDob.getDate();

      //get the current date from the system
      var now = new Date();
      //extract the year, month, and date from current date
      var currentMonth = now.getMonth();
      var currentDate = now.getDate();

      //get months
      if (currentMonth >= dobMonth)
        //get months when current month is greater
        var monthAge = currentMonth - dobMonth;
      else {
        // yearAge--;
        var monthAge = 12 + currentMonth - dobMonth;
      }

      //get days
      if (currentDate >= dobDate)
        //get days when the current date is greater
        var dateAge = currentDate - dobDate;
      else {
        monthAge--;
        var dateAge = 31 + currentDate - dobDate;

        if (monthAge < 0) {
          monthAge = 11;
          //  yearAge--;
        }
      }
      return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'

    } else {


      if (ageResult != null) {

        var patientAgeResult = new Date(ageResult);

        var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        var ageValue = Difference_In_Days / 365.25;
        ageValue = Math.trunc(ageValue); //Get Before Decimal Value

        //extract the year, month, and date from user date input
        var dobYear = patientAgeResult.getFullYear();
        var dobMonth = patientAgeResult.getMonth();
        var dobDate = patientAgeResult.getDate();

        //get the current date from the system
        var now = new Date();
        //extract the year, month, and date from current date
        var currentMonth = now.getMonth();
        var currentDate = now.getDate();

        //get months
        if (currentMonth >= dobMonth)
          //get months when current month is greater
          var monthAge = currentMonth - dobMonth;
        else {
          // yearAge--;
          var monthAge = 12 + currentMonth - dobMonth;
        }

        //get days
        if (currentDate >= dobDate)
          //get days when the current date is greater
          var dateAge = currentDate - dobDate;
        else {
          monthAge--;
          var dateAge = 31 + currentDate - dobDate;

          if (monthAge < 0) {
            monthAge = 11;
            //  yearAge--;
          }
        }
        return ageValue + ' Y ' + monthAge + ' M ' + dateAge + ' D'
      } else {
        return '-'

      }
    }
  }

  searchpatientfromOutSide(searchWord){
        if(!this.tenantId || this.tenantId === 'null' || this.tenantId === 'undefined' || !this.branchId){return;}
    if(searchWord!==null){
    var searchData={
      "searchWord":searchWord,
      "fromDate": null,
      "toDate": null,
      "skip": 0,
      "take": 100,
      "tenantId":this.tenantId,
      "branchId":this.multiBranchAccess ? null : this.branchId,
    };

    const apiUrl = `PatientRegistrationMst/${this.tenantId}/${this.branchId}/newPatientList`;

  this.patRegSrvc.searchList(apiUrl, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((dataResponse: any) => {
      if(dataResponse.details.length>0){
        this.patientDatas=dataResponse.details;
        this.patientData=dataResponse.details;
        this.selectPat(this.patientDatas[0])
        this.isquicksearch=true;
      }
      else{
        this.patientDatas=[];
      }
    },
    (error) => {
    },
    () => {
    });
    this.patientSelected = false;
    this.count = 1;
    //this.getdefaultEHRpage();
  }
}

searchList(){
  this.searchpatientfromOutSide(this.searchWord)
}

fetchPageAccess(){

  this.pageTaskIds =[];
   this.pageTaskIds.push(access.task.ABHAREG,access.task.PATIENT_PACKAGE,access.task.ADMMST,access.task.OTBOOKMST,access.task.PATIENTMONITORING,access.task.DISCHARGELIST,access.task.PGPATWALLETTRANS,);
  let matrixSearchData={
    taskId: this.pageTaskIds,
    UserId:localStorage.getItem("userType")
  }
  this.rolesService.create(`${this.apiUrl}/userrole/${this.tenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  this.userAccessData = data;

  }, (error) => {
  }, () => {
    let packageView = this.userAccessData.filter(element => access.task.PATIENT_PACKAGE == element.taskID &&element.actionID == access.action.VIEW && element.permission == "true");
    if(packageView.length > 0) this.packageFlag = true;

    let otView = this.userAccessData.filter(element => access.task.OTBOOKMST == element.taskID &&element.actionID == access.action.VIEW && element.permission == "true");
    if(otView.length > 0) this.otFlag = true;

    var admList = this.userAccessData.filter(element => access.task.ADMMST == element.taskID  && element.actionID == access.action.VIEW && element.permission == "true");
      if(admList.length > 0) this.admissionlistFlag = true;
    var dischargeList = this.userAccessData.filter(element => access.task.DISCHARGELIST == element.taskID  && element.actionID == access.action.VIEW && element.permission == "true");
    if(dischargeList.length > 0) this.dischargeListFlag = true;
    var admissioncancelledList = this.userAccessData.filter(element => access.task.ADMMST == element.taskID  && element.actionID == access.action.VIEW && element.permission == "true");
    if(admissioncancelledList.length > 0) this.cancelledListFlag = true;
    var patientMonitoringList = this.userAccessData.filter(element => access.task.PATIENTMONITORING == element.taskID  && element.actionID == access.action.VIEW && element.permission == "true");
    if(patientMonitoringList.length > 0) this.caretakerFlag = true;

    if(!this.dischargeListFlag&&!this.admissionlistFlag &&!this.cancelledListFlag&&!this.caretakerFlag){this.ipFlag=false;}else{this.ipFlag=true;}

    let wallet = this.userAccessData.filter(element => access.task.PGPATWALLETTRANS == element.taskID &&element.actionID == access.action.VIEW && element.permission == "true");
    if(wallet.length > 0) this.walletFlag = true;

    //Access ABHA create Popup
    let abhaView = this.userAccessData.filter(element => access.task.ABHAREG == element.taskID && element.actionID == access.action.VIEW && element.permission == "true" )
    if(abhaView.length > 0) this.isAbhaView = true;

  });


}

patientConversionPopUP(det){
  this.convertData = det;
  this.convertFlag = true;
}

patientConversion(row){
  if(!!row){
  const searchData={}
  this.rolesService.update(`${this.apiUrl}/PatientRegistrationMst/${this.tenantId}/${this.branchId}/converUnregPatToRegPat/${row?.regId}`, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {},()=>{
    this.toaster.ForDanger("Not Registered");
  },()=>{
    this.convertData = null;
    this.convertFlag = false;
    this.searchpatient();;
    this.toaster.ForSuccess("Registered Successfully");
  }) }}  


}
